const BRANCH_SORTING = [
  {
    label: 'DESCRIPTION',
    value: 'branchDescription',
    isDefault: true,
  },
];

export default BRANCH_SORTING;
